import { Home as HomeIcon, Sun, Utensils, Activity, Eye, Calendar } from "lucide-react";
import { IMG } from "@/lib/site";
import PageHero from "@/components/PageHero";
import SectionHeading from "@/components/SectionHeading";
import CtaSection from "@/components/CtaSection";

const routine = [
  { icon: HomeIcon, t: "Spazi adeguati", d: "Aree pulite, sicure e pensate per il riposo." },
  { icon: Eye, t: "Controllo quotidiano", d: "Lo sguardo attento di chi conosce ogni ospite." },
  { icon: Utensils, t: "Alimentazione su misura", d: "Rispettiamo l'alimentazione del tuo cane." },
  { icon: Activity, t: "Movimento e gioco", d: "Attività quotidiana per restare attivi e sereni." },
  { icon: Sun, t: "Tempo all'aria aperta", d: "Spazi esterni curati per le uscite giornaliere." },
  { icon: Calendar, t: "Gestione personalizzata", d: "Ogni cane viene trattato secondo le sue abitudini." },
];

export default function Pensione() {
  return (
    <div data-testid="page-pensione">
      <PageHero
        overline="Pensione per cani · Aperta tutto l'anno"
        title="Una seconda casa per il tuo cane"
        lead="Un ambiente sicuro e accogliente dove il tuo amico può sentirsi seguito, anche quando sei lontano."
        image={IMG.pensione}
        primaryCta={{ to: "/contatti", label: "Verifica disponibilità" }}
        secondaryCta={{ to: "/allevamento", label: "Scopri l'allevamento" }}
      />

      <section className="py-16 sm:py-24" data-testid="seconda-casa">
        <div className="max-w-5xl mx-auto px-6 sm:px-10 lg:px-12 text-center reveal">
          <p className="text-xs uppercase tracking-[0.25em] font-semibold text-[#7A1F1F] mb-5">
            Una seconda casa
          </p>
          <h2 className="font-serif text-4xl sm:text-5xl text-[#1A1710] leading-tight">
            Lo accogliamo come uno dei nostri.
          </h2>
          <p className="mt-6 text-lg text-[#6B5F4A] leading-relaxed">
            Dal 2024 il nostro allevamento si affianca a un servizio di pensione
            dedicato, aperto tutto l'anno, dove gli ospiti vengono trattati e
            accuditi con la stessa attenzione che riserviamo abitualmente ai
            nostri cani.
          </p>
        </div>
      </section>

      <section className="py-16 sm:py-24 bg-[#EDD895]/60" data-testid="routine">
        <div className="max-w-7xl mx-auto px-6 sm:px-10 lg:px-12">
          <SectionHeading overline="Cura durante il soggiorno" title="Una routine pensata per il benessere." />
          <div className="mt-14 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
            {routine.map((r, i) => (
              <div
                key={r.t}
                className="reveal bg-[#F5E6C0] border border-[#D9C48A] rounded-3xl p-7"
                style={{ transitionDelay: `${i * 60}ms` }}
              >
                <div className="w-12 h-12 rounded-2xl bg-[#EDD895] grid place-items-center mb-5 text-[#7A1F1F]">
                  <r.icon className="w-6 h-6" strokeWidth={1.4} />
                </div>
                <h4 className="font-sans font-semibold text-[#1A1710] text-lg">{r.t}</h4>
                <p className="mt-2 text-sm text-[#6B5F4A] leading-relaxed">{r.d}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="py-16 sm:py-24" data-testid="periodi">
        <div className="max-w-7xl mx-auto px-6 sm:px-10 lg:px-12 grid grid-cols-1 lg:grid-cols-12 gap-12 items-center">
          <div className="lg:col-span-6 reveal order-2 lg:order-1">
            <SectionHeading
              overline="Brevi o lunghi periodi"
              title="Sempre al fianco delle tue esigenze."
              lead="Vacanze, impegni di lavoro, weekend o necessità temporanee: la pensione Colli Storici è la soluzione affidabile per ogni momento."
            />
            <ul className="mt-7 space-y-3 text-[#6B5F4A]">
              {[
                "Soggiorni brevi: weekend, viaggi di lavoro",
                "Soggiorni lunghi: vacanze, periodi prolungati",
                "Comunicazione costante con il proprietario",
                "Massima tranquillità in ogni momento",
              ].map((p) => (
                <li key={p} className="flex gap-3">
                  <span className="mt-2 w-1.5 h-1.5 rounded-full bg-[#8B4A2B] flex-none" />
                  <span>{p}</span>
                </li>
              ))}
            </ul>
          </div>
          <div className="lg:col-span-6 reveal order-1 lg:order-2">
            <div className="aspect-[4/3] rounded-3xl overflow-hidden">
              <img src={IMG.pensione} alt="Pensione per cani" className="w-full h-full object-cover" />
            </div>
          </div>
        </div>
      </section>

      <CtaSection
        title="Richiedi disponibilità per la pensione"
        lead="Contattaci con le date del soggiorno: ti risponderemo con la disponibilità e tutte le informazioni utili."
        primaryLabel="Contattaci per la pensione"
      />
    </div>
  );
}
